import React from 'react'
import { Modal, ModalContent, ModalTitle, ModalClose } from '@mytours/components'

import SyncedTranscript from './SyncedTranscript'
import strings from '../../../strings'
import { getDirMode } from '../../platform'

import './styles/transcript-sheet.less'

interface Props {
	open: boolean
	onClose: () => void
	// Names the dialog. The stop's name, not the audio item's — a title is often just the file's stem ("2").
	title?: string
	transcription?: string
	transcriptionFormat?: 'html' | 'timecoded'
	mediaItemId?: number
	currentTime: number
	isPlaying: boolean
}

/** A track's transcript, full screen, on the library's Modal for the focus trap, Escape and accessible name. */
const TranscriptSheet: React.FC<Props> = ({
	open,
	onClose,
	title,
	transcription,
	transcriptionFormat,
	mediaItemId,
	currentTime,
	isPlaying,
}) => (
	<Modal open={open} onOpenChange={next => !next && onClose()} variant="fullscreen">
		<ModalContent className="transcript-sheet" dir={getDirMode()}>
			<div className="transcript-sheet-header">
				<ModalClose className="transcript-sheet-close" aria-label={strings.accessibility_close_transcript}>
					<i className="far fa-chevron-down" aria-hidden="true" />
				</ModalClose>
				<ModalTitle className="transcript-sheet-title">{title}</ModalTitle>
			</div>
			<div className="transcript-sheet-body">
				<div className="transcript-sheet-label">{strings.transcript}</div>
				<SyncedTranscript
					variant="modal"
					transcription={transcription}
					transcriptionFormat={transcriptionFormat}
					mediaItemId={mediaItemId}
					currentTime={currentTime}
					isPlaying={isPlaying}
				/>
			</div>
		</ModalContent>
	</Modal>
)

export default TranscriptSheet
